export const environment = {
  production: true,
  apiUrl: 'https://pdv-app-production-73e7.up.railway.app/api'
};